// action - state management
import { ACCOUNT_INITIALIZE, LOGIN, LOGOUT, UPDATE } from './actions';

export const initialState = {
    token: '',
    isLoggedIn: false,
    isInitialized: false,
    user: null,
    admin: false
};

//-----------------------|| ACCOUNT REDUCER ||-----------------------//

const accountReducer = (state = initialState, action) => {
    switch (action.type) {
        case ACCOUNT_INITIALIZE: {
            const { isLoggedIn, user, token, admin } = action.payload;
            return {
                ...state,
                admin,
                isLoggedIn,
                isInitialized: true,
                token,
                user
            };
        }
        case LOGIN: {
            const { user, admin } = action.payload;
            return {
                ...state,
                isLoggedIn: true,
                user,
                admin
            };
        }
        case UPDATE: {
            const { user } = action.payload;
            return {
                ...state,
                user
            };
        }
        case LOGOUT: {
            return {
                ...state,
                isLoggedIn: false,
                token: '',
                user: null
            };
        }
        default: {
            return { ...state };
        }
    }
};

export default accountReducer;
